export default {
  getSaleLead: (state) => state.saleLead,
};
